<template>
	<el-dialog
		title="销账"
		:visible.sync="dialogVisible"
		width="70%"
		top="10vh"
		:close-on-click-modal="false"
		:before-close="handleClose"
		custom-class="depreciation-dialog">
		<el-descriptions :column="4" border style="margin-bottom: 20px">
			<el-descriptions-item label="销账批次号">DG20231007000003</el-descriptions-item>
			<el-descriptions-item label="交易日期">2023-10-17 09:15:00</el-descriptions-item>
			<el-descriptions-item label="流水客户名称">王五</el-descriptions-item>
			<el-descriptions-item label="发生金额">260.1800</el-descriptions-item>
		</el-descriptions>
		<!-- 表格 -->
		<BaseTable
			:selection="false"
			shadow="never"
			:loading="loading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="pageNum"
			:pageSize="pageSize"
			@page-change="pageChange"
			@size-change="sizeChange">
			<template #writeOffAmount="{ row }">
				<div v-if="row.isSummary">
					{{ row.writeOffAmount }}
				</div>
				<el-input v-model="row.writeOffAmount" size="mini" v-else />
			</template>
			<template #writeOffType="{ row }">
				<el-select
					v-model="row.writeOffType"
					placeholder="请选择"
					style="width: 100%"
					size="mini"
					v-if="!row.isSummary">
					<el-option label="已收款" value="已收款" />
					<el-option label="已减免" value="已减免" />
					<el-option label="已坏账" value="已坏账" />
				</el-select>
			</template>
		</BaseTable>
		<!-- 按钮 -->
		<span slot="footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button type="primary" @click="handleSubmit">确认销账</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		name: 'WriteOffDetailsOffDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
						this.fileList = [];
						this.form.voucherUrl = '';
					});
				}
			},
		},
		data() {
			return {
				total: 2,
				pageNum: 1,
				pageSize: 10,
				loading: false,
				columns: [
					{ prop: 'resourceCode', label: '资源编码' },
					{ prop: 'customerName', label: '客户名称', width: '120px' },
					{ prop: 'feeType', label: '费用类型', width: '100px' },
					{ prop: 'chargeItem', label: '收费项目', width: '160px' },
					{ prop: 'billPeriod', label: '应收账期', width: '120px' },
					{ prop: 'principalUncollected', label: '本金欠收', width: '120px' },
					{ prop: 'penaltyUncollected', label: '违约金欠收', width: '120px' },
					{ prop: 'totalUncollected', label: '欠收合计', width: '120px' },
					{ prop: 'writeOffAmount', label: '销账金额', width: '120px', slot: 'writeOffAmount' },
					{ prop: 'writeOffType', label: '销账类型', width: '120px', slot: 'writeOffType' },
				],
				tableData: [
					{
						resourceCode: '01-0303',
						customerName: '厉千凡',
						feeType: '应收',
						chargeItem: '车位管理费',
						billPeriod: '2023-10',
						principalUncollected: 70.0,
						penaltyUncollected: 0.0,
						totalUncollected: 70.0,
						writeOffAmount: 70.0,
						writeOffType: '已收款',
					},
					{
						resourceCode: '01-0303',
						customerName: '厉千凡',
						feeType: '应收',
						chargeItem: '物业管理费',
						billPeriod: '2023-10',
						principalUncollected: 218.38,
						penaltyUncollected: 0.0,
						totalUncollected: 218.38,
						writeOffAmount: 218.38,
						writeOffType: '已收款',
					},
					{
						resourceCode: '合计：',
						customerName: '',
						feeType: '',
						chargeItem: '',
						billPeriod: '',
						principalUncollected: 288.38,
						penaltyUncollected: 0.0,
						totalUncollected: 288.38,
						writeOffAmount: 288.38,
						writeOffType: '',
						isSummary: true,
					},
				],
			};
		},
		created() {},
		methods: {
			pageChange(page) {
				this.pageNum = page;
			},
			sizeChange(size) {
				this.pageSize = size;
			},
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleSubmit() {},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.depreciation-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #bbbbbb;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}
</style>
